import React from 'react';
import FacilityStore from '../../stores/FacilityStore';
import ViewerStore from '../../stores/ViewerStore';

const hasSelectedAsset = () => {
    const selectedHierarchyItems = ViewerStore.getSelectedHierarchyItems();

    if (selectedHierarchyItems?.length === 1) {
        return true;
    }

    return !!FacilityStore.getAssetById(ViewerStore.getSelectedAsset());
};

export const useAssetInformationSelection = () => {
    const [isAssetSelected, setIsAssetSelected] = React.useState(hasSelectedAsset);

    React.useEffect(() => {
        const handleSelectionChange = () => setIsAssetSelected(hasSelectedAsset());

        FacilityStore.addChangeListener(handleSelectionChange);
        ViewerStore.addChangeListener(handleSelectionChange);

        return () => {
            FacilityStore.removeChangeListener(handleSelectionChange);
            ViewerStore.removeChangeListener(handleSelectionChange);
        };
    }, []);

    return isAssetSelected;
};
